import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Box } from "../../Layout/Box/Box";

export class DialogContent extends BaseComponent<IDialogContentProps, IDialogContentState>
{
    public render(): JSX.Element
    {
        return (
            <Box>
                {this.props.children}
            </Box>
        );
    }
}

export interface IDialogContentProps
{
    children: ReactNode;
}

export interface IDialogContentState { }
